import { isUserLoggedIn } from "./userAuth";

// Whether the discount paywalls (the exit-intent last-chance offer and the
// post-purchase upsell) stay hidden for this visitor: a live Enterprise plan
// never sees them, and a live Express / Pro plan only sees them once
// its downloads are gone — a subscriber with an allowance left has nothing to
// buy. Gifted account downloads (bonusDownloads, no plan) count the same
// way. Guests and lapsed plans with nothing left see them as always.
export function paywallsSuppressed() {
  if (!isUserLoggedIn()) return false;
  try {
    const u = JSON.parse(localStorage.getItem("userInfo") || "null") || {};
    const sub = u.subscription;
    if (!sub || !["active", "trialing", "cancelling", "past_due"].includes(sub.status)) {
      return (u.bonusDownloads || 0) > 0;
    }
    if (sub.tier === "business") return true;
    const rem = sub.downloads_remaining;
    return rem === -1 || rem > 0;
  } catch { return false; }
}
